import { cn } from '@/utils/classname';
import { SVGProps } from 'react';
import { fill, stroke } from './classNames';

export const GearIcon = ({
  isActive,
  className,
  ...props
}: { isActive: boolean } & SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="22"
      viewBox="0 0 22 22"
      width="22"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={cn('group', className)}
    >
      <path
        className={fill(isActive)}
        clipRule="evenodd"
        d="M13.6793 4.3867C14.2998 4.57024 14.999 4.41729 15.4884 3.92786C16.2018 3.21556 17.3566 3.21556 18.07 3.92786L18.0722 3.93114C18.7855 4.64344 18.7855 5.79929 18.0722 6.51159C17.5827 7.00102 17.4298 7.70021 17.6144 8.32074L17.5718 8.21914C17.881 8.78723 18.4829 9.17397 19.1756 9.17397C20.1828 9.17397 21 9.99006 21 10.9984V11.0039C21 12.0112 20.1828 12.8283 19.1756 12.8283C18.4829 12.8283 17.881 13.214 17.5718 13.7832L17.6144 13.6805C17.4309 14.3021 17.5827 15.0002 18.0722 15.4907C18.7855 16.203 18.7855 17.3589 18.0722 18.0712L18.07 18.0744C17.3566 18.7867 16.2018 18.7867 15.4895 18.0744C14.999 17.585 14.2998 17.4321 13.6793 17.6156L13.782 17.573C13.2128 17.8822 12.8272 18.4852 12.8272 19.1779C12.8272 20.184 12.01 21.0012 11.0027 21.0012H10.9973C9.99 21.0012 9.17283 20.184 9.17283 19.1779C9.17283 18.4852 8.78609 17.8822 8.218 17.573L8.3196 17.6156C7.69908 17.4321 7.00098 17.585 6.51046 18.0744C5.79816 18.7867 4.64341 18.7867 3.93003 18.0744L3.92675 18.0712C3.21445 17.3589 3.21445 16.203 3.92675 15.4918C4.41618 15.0013 4.56913 14.3021 4.38559 13.6816L4.4271 13.7832C4.11903 13.2151 3.51598 12.8283 2.82335 12.8283C1.81608 12.8283 1 12.0112 1 11.0039V10.9984C1 9.99115 1.81608 9.17397 2.82335 9.17397C3.51598 9.17397 4.11903 8.78833 4.4271 8.21914L4.38559 8.32184C4.56913 7.7013 4.41618 7.00211 3.92566 6.51159C3.21336 5.79929 3.21336 4.64453 3.92566 3.93114L3.93003 3.92786C4.64232 3.21556 5.79707 3.21556 6.51046 3.92786C6.99989 4.41839 7.69798 4.57133 8.3196 4.3867L8.218 4.42931C8.78609 4.12014 9.17283 3.51818 9.17283 2.82554C9.17283 1.81718 9.98891 1 10.9973 1H11.0016C12.01 1 12.8261 1.81718 12.8261 2.82554C12.8261 3.51818 13.2117 4.12014 13.7809 4.42931L13.6793 4.3867Z"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.68"
      />
      <path
        className={stroke(isActive)}
        d="M13.1844 11.0009C13.1844 12.207 12.2055 13.1859 10.9994 13.1859C9.79331 13.1859 8.81445 12.207 8.81445 11.0009C8.81445 9.79478 9.79331 8.81592 10.9994 8.81592C12.2055 8.81592 13.1844 9.79478 13.1844 11.0009"
        strokeWidth="1.68"
      />
    </svg>
  );
};
